import { Tab, Tabs } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

function AdminTabs({ currentTab, handleTabChange }) {
  const { t } = useTranslation()
  return (
    <Tabs value={currentTab} onChange={handleTabChange}>
        <Tab label={t('allAdmins')} />
        <Tab label={t('allUsers')} />
        <Tab label={t('allPatients')} />
      </Tabs>
  )
}

function UserTabs({ currentTab, handleTabChange }) {
  const { t } = useTranslation()
  return (
    <Tabs value={currentTab} onChange={handleTabChange}>
        <Tab label={t('allUsers')} />
        <Tab label={t('allPatients')} />
      </Tabs>
  )
}

export { AdminTabs, UserTabs }